import { useEffect } from "react";
import { effectiveConsent, CONSENT_CHANGED_EVENT } from "@/lib/cookieConsent";

/**
 * Consent Mode v2 bridge (post-GTM install).
 *
 * The GTM container (GTM-P9KCQTKH) is now loaded statically from
 * `public/index.html`, together with a `gtag('consent','default', ...)` call
 * that sets EVERYTHING to `denied` before GTM boots. This component is only
 * responsible for pushing `gtag('consent','update', ...)` at runtime whenever
 * the user changes their choice through the CookieBanner.
 *
 *  - Analytics cookies → analytics_storage
 *  - Marketing cookies → ad_storage / ad_user_data / ad_personalization
 *
 * GTM (and any GA4 / Google Ads tag configured inside it) then reads the
 * updated consent state on the next event and behaves accordingly.
 */
const GoogleTags = () => {
    useEffect(() => {
        if (typeof window === "undefined") return undefined;

        const apply = () => {
            const c = effectiveConsent();
            const gtag = window.gtag;
            if (typeof gtag !== "function") return;
            try {
                gtag("consent", "update", {
                    analytics_storage: c.analytics ? "granted" : "denied",
                    ad_storage: c.marketing ? "granted" : "denied",
                    ad_user_data: c.marketing ? "granted" : "denied",
                    ad_personalization: c.marketing ? "granted" : "denied",
                });
            } catch (_) {
                /* no-op */
            }
        };

        // Reflect the currently persisted consent as soon as we mount — this
        // covers reloads after the user has already made a choice.
        apply();
        window.addEventListener(CONSENT_CHANGED_EVENT, apply);
        return () => window.removeEventListener(CONSENT_CHANGED_EVENT, apply);
    }, []);

    return null;
};

export default GoogleTags;
